import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="board-ground w-full border-y-4 border-gold" data-id="element-46" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-47" data-mp="1uy2zj31x9h5d">
        <h2 className="chalk-underline font-display text-white text-[28px] sm:text-5xl" data-id="element-48" data-mp="1v05y4bh54ilp">
          Stop improvising.{' '}
          <span className="text-gold" data-id="element-49" data-mp="1kzwysoruqh23">Walk into club ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-50" data-mp="1l1zsbis7qsbk">
          A full season of ready-to-teach chess club sessions — lessons,
          puzzles, activities and printable worksheets. Planned, sequenced,
          ready to teach.
        </p>

        <div className="mt-7" data-id="element-51" data-mp="17a1q7rwx5wow">
          <Countdown size="sm" tone="dark" data-id="element-52" data-mp="176xgyg4lkard" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-53" data-mp="128cfkddlzl1c">
          <div data-id="element-54" data-mp="3vforl35q61cd">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-55" data-mp="3vf57pgwil2vp">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-white" data-id="element-56" data-mp="4226zip1a9wc">
              No-Prep Chess Club Megapack — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-57" data-mp="3qhdgkp3p1ksk">
            <span className="text-[15px] text-white/60 line-through" data-id="element-58" data-mp="3qdzgxomezpot">$106</span>
            <span className="font-display text-4xl leading-none text-white" data-id="element-59" data-mp="hyfo2qpno9aa">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-60" data-mp="82uhsgdk0muq">
          <CtaButton data-id="element-61" data-mp="822xi1peqbjr">Yes, I want the system — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-62" data-mp="d04e8fzd1ys2">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-63" data-mp="2xsfz2o7b3s0v">
                <span className="h-1.5 w-1.5 rounded-[1px] bg-gold" data-id="element-64" data-mp="148o0lfg8a4bj" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}